// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-pointer[data-v-c3f808da]{cursor:pointer}`, "",{"version":3,"sources":["webpack://./ClientApp/components/activity/Activities.vue"],"names":[],"mappings":"AACA,4BACE,cAAA","sourcesContent":["\r\n.c-pointer {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
